import { useCallback, useEffect } from 'react';
import Button from 'components/Basic/Button';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'store';
import { setIrrandiance } from 'store/slices/IrradianceSlice';
import { isModeDefault } from '../../../util';
import { isTypingInField } from 'components/tool/Editor/ButtonDiv/ToggleSatelliteViewBtn';

export function IrradianceToggle() {
	const { showIrradiance } = useSelector((state: RootState) => state.Irradiance.data);
	const { hideSatelliteOverlay } = useSelector((state: RootState) => state.toolNewPostions.data);
	const { mode } = useSelector((state: RootState) => state.roofData.data);
	const dispatch = useDispatch();

	const disabled = hideSatelliteOverlay;
	const visible = isModeDefault(mode);

	const handleIrradianceClick = useCallback(() => {
		dispatch(setIrrandiance({ showIrradiance: !showIrradiance }));
	}, [dispatch, showIrradiance]);

	// i / I toggles (only when shown + enabled)
	useEffect(() => {
		if (!visible || disabled) return;
		const handleKeyUp = (event: KeyboardEvent) => {
			if (event.ctrlKey || event.metaKey || event.altKey || isTypingInField(event.target)) return;
			if (event.key === 'i' || event.key === 'I') handleIrradianceClick();
		};
		window.addEventListener('keyup', handleKeyUp);
		return () => window.removeEventListener('keyup', handleKeyUp);
	}, [visible, disabled, handleIrradianceClick]);

	if (!visible) {
		return null;
	}

	return <Button style={{
		color: showIrradiance ? 'var(--darkAccentColor)' : 'var(--defaultIconColor)',
		background: `${showIrradiance ? 'var(--secondary)' : 'var(--defaultBgColor)'}`,
		border: `${showIrradiance ? '1px solid var(--secondary)' : '1px solid var(--controlBorderColor)'}`,
	}}
	onClick={handleIrradianceClick}
	disabled={disabled}
	className={'btnFont0 btnHover irradiance-btn ' + `${showIrradiance ? ' active' : ''}`}>
		<svg width="18" height="19" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<ellipse cx="9.43194" cy="10.0048" rx="3.48858" ry="3.50336" stroke={`${showIrradiance ? 'var(--darkAccentColor)' : 'var(--defaultIconColor)'}`} strokeWidth="1.6" />
			<ellipse cx="9.43194" cy="10.0048" rx="3.48858" ry="3.50336" stroke={`${showIrradiance ? 'var(--darkAccentColor)' : 'var(--defaultIconColor)'}`} strokeWidth="1.6" />
			<path d="M15.2988 10.2814H17.888" stroke={`${showIrradiance ? 'var(--darkAccentColor)' : 'var(--defaultIconColor)'}`} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M15.2988 10.2814H17.888" stroke={`${showIrradiance ? 'var(--darkAccentColor)' : 'var(--defaultIconColor)'}`} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M1 10.3154H3.58918" stroke={`${showIrradiance ? 'var(--darkAccentColor)' : 'var(--defaultIconColor)'}`} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M1 10.3154H3.58918" stroke={`${showIrradiance ? 'var(--darkAccentColor)' : 'var(--defaultIconColor)'}`} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M9.2832 15.8447L9.2832 18.4449" stroke={`${showIrradiance ? 'var(--darkAccentColor)' : 'var(--defaultIconColor)'}`} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M9.2832 15.8447L9.2832 18.4449" stroke={`${showIrradiance ? 'var(--darkAccentColor)' : 'var(--defaultIconColor)'}`} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M9.50586 1.55554L9.50586 4.15569" stroke={`${showIrradiance ? 'var(--darkAccentColor)' : 'var(--defaultIconColor)'}`} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M9.50586 1.55554L9.50586 4.15569" stroke={`${showIrradiance ? 'var(--darkAccentColor)' : 'var(--defaultIconColor)'}`} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M13.3867 14.3562L15.2175 16.1948" stroke={`${showIrradiance ? 'var(--darkAccentColor)' : 'var(--defaultIconColor)'}`} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M13.3867 14.3562L15.2175 16.1948" stroke={`${showIrradiance ? 'var(--darkAccentColor)' : 'var(--defaultIconColor)'}`} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M3.25195 4.22534L5.08278 6.06393" stroke={`${showIrradiance ? 'var(--darkAccentColor)' : 'var(--defaultIconColor)'}`} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M3.25195 4.22534L5.08278 6.06393" stroke={`${showIrradiance ? 'var(--darkAccentColor)' : 'var(--defaultIconColor)'}`} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M5.21484 14.0181L3.38402 15.8567" stroke={`${showIrradiance ? 'var(--darkAccentColor)' : 'var(--defaultIconColor)'}`} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M5.21484 14.0181L3.38402 15.8567" stroke={`${showIrradiance ? 'var(--darkAccentColor)' : 'var(--defaultIconColor)'}`} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M15.4355 4.07275L13.6047 5.91134" stroke={`${showIrradiance ? 'var(--darkAccentColor)' : 'var(--defaultIconColor)'}`} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M15.4355 4.07275L13.6047 5.91134" stroke={`${showIrradiance ? 'var(--darkAccentColor)' : 'var(--defaultIconColor)'}`} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
		<label>Irradiance</label>
	</Button>;

}